<template>
  <div class="product-info-two">
    <div class="product-info-content">
      <section class="product-img-info">
        <div>
          <el-carousel
            height="360px"
            :autoplay="false"
            ref="elcarousel"
            arrow="always"
            @change="changeEvent"
          >
            <el-carousel-item
              :name="i + 'name'"
              v-for="(item, i) in dataImg"
              :key="i"
            >
              <img :src="`${$queryUrl}${item}`" />
            </el-carousel-item>
          </el-carousel>
          <div class="small-img-box">
            <div
              @click="selectImg(i)"
              :class="active === i && 'actived'"
              v-for="(item, i) in dataImg"
              :key="i"
            >
              <img :src="`${$queryUrl}${item}`" />
            </div>
          </div>
        </div>
        <div class="img-content">
          <h3>{{ dataList[0].productName }}</h3>
          <div>Model Number {{ dataList[0].modelNumber }}</div>
          <div>Dumber of pixels {{ dataList[0].numberOfPixels }}</div>
          <!-- <div>Display mode Normally black {{ dataList[0].displayMode }}</div> -->
          <div>LCM Iuminance {{ dataList[0].lcmIuminance }}</div>
          <!-- <div>Product description:</div> -->
        </div>
      </section>
    </div>
    <div class="description">{{$t("Specifications")}}</div>
    <section class="product-description">
      <el-table border :data="aboutTable" style="width: 100%">
        <el-table-column prop="label" label="Item"> </el-table-column>
        <el-table-column prop="name" label="Contents">
          <template slot-scope="scope">
            {{ dataList[0][scope.row.key] }}
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="Unit"> </el-table-column>
      </el-table>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    dataImg: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      active: 0,
      aboutTable: [
        { label: "Viewing dirction", key: "viewingDirection", unit: "" },
        { label: "Number of pixels", key: "numberOfPixels", unit: "-" },
        // { label: "Display mode", key: "displayMode", unit: "-" },
        // { label: "interface", key: "productInterface", unit: "" },
        { label: "Active area", key: "activeArea", unit: "mm" },
        // { label: "Outine", key: "outline", unit: "mm" },
        // { label: "Pixel pitch", key: "pixelPitch", unit: "mm" },
        // { label: "Number of color", key: "colorDepth", unit: "-" },
        { label: "LCM Iuminance", key: "lcmIuminance", unit: "cd/㎡" },
        // { label: "Response time(Tr+Tf)", key: "responseTime", unit: "-" },
        { label: "Contrast ratio", key: "contrastRatio", unit: "-" }
        // { label: "Transmittance", key: "transmittance", unit: "%" },
        // {
        //   label: "Operaring temperature",
        //   key: "operaringTemperature",
        //   unit: "°C"
        // },
        // { label: "Storage temperature", key: "temperature", unit: "°C" }
      ]
    };
  },
  methods: {
    selectImg(index) {
      this.active = index;
      this.$refs.elcarousel.setActiveItem(index + "name");
    },
    changeEvent(index) {
      this.active = index;
    }
  }
};
</script>
<style lang="scss">
.product-info-content {
  width: 1200px;
  margin: 0 auto;
  .product-img-info {
    display: flex;
    border-bottom: 1px dashed #ccc;
    margin-bottom: 40px;
    > div {
      width: 50%;
    }
    .el-carousel__item {
      text-align: center;
      padding-top: 40px;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .img-content {
      padding: 0 40px;
      h3 {
        line-height: 60px;
        color: #071c83;
        font-size: 28px;
        border-bottom: 1px dashed #ccc;
        margin-bottom: 24px;
      }
      div {
        line-height: 40px;
      }
    }
    .small-img-box {
      display: flex;
      justify-content: center;
      height: 60px;
      div {
        width: 50px;
        height: 50px;
        margin: 0 4px;
        border: 1px solid #ccc;
        padding: 2px;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .actived {
        border-color: #409eff;
      }
    }
  }
}
.description{
  margin-top: 40px;
}
.product-description {
  // margin: 40px 0;
  .el-table th {
    background: #f5f7fa;
  }
}
</style>
